import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addMonths,
  subMonths,
  format,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  eachDayOfInterval,
  isSameMonth,
  isSameDay,
  differenceInDays,
  addDays, 
  subDays
} from "date-fns";
import styles from "./BeaconDates.module.css"
import calendar from "../../assets/images/calendar.svg";
import user from "../../assets/images/user.svg";
import useWindowSize from "../../utils/useWindowSize";
import { useTranslation } from "react-i18next";
import { pluralWords } from "../../utils/utils";
import {getWeeksInventoryApi} from "../../Services/mainPageService"
import dayjs from "dayjs";
import hotelInfoTypes from "../../redux/actionType/hotelInfoTypes";
import { FaBell } from "react-icons/fa";
import InventoryRetargModal from "../../components/Modals/InventoryRetargetting/InventoryRetargModal";

const BeaconCalendar = ({ setDateRange, setEnablePopup, adults, child }) => {
  const today = new Date();
  today?.setHours(0, 0, 0, 0);
  const { width } = useWindowSize();
  const { t } = useTranslation();
  const dispatch = useDispatch()

  const [currentMonth, setCurrentMonth] = useState(startOfMonth(today));
  const [selectedRange, setSelectedRange] = useState({ start: null, end: null });
  const [showCalendar, setShowCalendar] = useState(false);
  const [newPrices, setNewPrices] = useState({});
  const [hoveredDate, setHoveredDate] = useState(null);
  const [showNotifyPopup, setShowNotifyPopup] = useState(false);
  const [hoverDateRange, setHoverDateRange] = useState({ startDate: '', endDate: '' });
  const calendarRef = useRef(null);
  const { hotelData, totalPeople=2, CalendarPrices = {}, dateRange = {} } = useSelector((state) => state.hotelInfo);
  let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  
  useEffect(() => {
    // default selected range on component mount that is today's date

    if (dateRange?.startDate && dateRange?.endDate && dateRange?.startDate?.$d && dateRange?.endDate?.$d){
      if (
        !(dateRange?.startDate?.$d instanceof Date) ||
        !(dateRange?.endDate?.$d instanceof Date)
      ) return;

      const formattedDateOne = dateRange?.startDate?.$d?.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "2-digit",
        });
  
        const formattedDateTwo = dateRange?.endDate?.$d?.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "2-digit",
          });

    setSelectedRange({ start: dateRange?.startDate?.$d, end: dateRange?.endDate?. $d });
      setDateRange({ //passing the data to mainpage for syncing with the other components
        startDate: dayjs(formattedDateOne).format("YYYY/MM/DD"),
        endDate: dayjs(formattedDateTwo).format("YYYY/MM/DD"),
      });
    }
  }, []);

  useEffect(() => {
    const fetchPrices = async () => {

      const formatDateToMonthYear = (dateString) => {
        const date = new Date(dateString);
        return date?.toLocaleString("en-US", { month: "long", year: "numeric" }); 
      };

      const formattedMonth = formatDateToMonthYear(currentMonth);

      if (CalendarPrices && CalendarPrices[formattedMonth]) {
        setNewPrices(CalendarPrices[formattedMonth]); 
        return;
      }

      const fromDate =
      format(currentMonth, "yyyy-MM-dd"); // First day of current month
      const toDate =
      format(endOfMonth(currentMonth), "yyyy-MM-dd"); // Last day of current month
      
      let obj = {}
      if (fromDate && toDate) {
        obj = {
          fromDate: fromDate,
          guestCount: 2,
          hotelId:hotelData?.id,
          timezone: timeZone,
          toDate: toDate
        } 
      }

      //crash preventio, no API call, no action further for prices if hotelId if obj does not have proper data
      if (!obj || !obj?.fromDate || !obj?.toDate || !obj?.hotelId) {
        return;
      }      

      try {
        let response = await getWeeksInventoryApi(obj)
        if (response?.status === 200 && response?.data && Array.isArray(response?.data) && response?.data?.length>0) {
          const priceData = Object.fromEntries(
            response?.data?.map(({ checkInDate, priceAfterDiscount, price, count }) => [
              checkInDate,
              {
                price: priceAfterDiscount || price,
                count: count
              }
            ])
          );

          dispatch({
            type: hotelInfoTypes.CALENDAR_PRICE_DISPLAY,
            payload: {
              [formattedMonth]: priceData,
            }
          });

          setNewPrices(priceData);
        }
        
      } catch (error) {
        console.log("Error fetching prices:", error);
      }
    };
  
    fetchPrices();
  }, [currentMonth, hotelData]);  

  const handlePrevMonth = () => {
    const previousMonth = subMonths(currentMonth, 1);
    if (previousMonth >= startOfMonth(today)) {
      setCurrentMonth(previousMonth);
    }
  };

  const handleNextMonth = () => setCurrentMonth(addMonths(currentMonth, 1));

  const isSoldOut = (day) => {
    if (!day) return;
    const dateKey = format(day, "yyyy-MM-dd");
    return newPrices[dateKey] && newPrices[dateKey]?.count === 0;
  };
  
  const handleDateClick = (day) => {
    if (!day || day < today ) return;
   
    if (selectedRange?.start && !selectedRange?.end && isSameDay(day, selectedRange?.start)) {
      setSelectedRange({ start: null, end: null });
      return;
    }
 
    if ((!selectedRange?.start || (selectedRange?.start && selectedRange?.end))) {
      setSelectedRange({ start: day, end: null });
    }

     else {
      const start = day < selectedRange?.start ? day : selectedRange?.start;
      const end = day > selectedRange?.start ? day : selectedRange?.start;
        const dateOne = new Date(start);
        const dateTwo = new Date(end);
       
        const formattedDateOne = dateOne?.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "2-digit",
        });

        const formattedDateTwo = dateTwo?.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "2-digit",
          });

        setDateRange({ //passing the data to mainpage for syncing with the other components
          startDate: dayjs(formattedDateOne).format("YYYY/MM/DD"),
          endDate: dayjs(formattedDateTwo).format("YYYY/MM/DD"),
        });
        setEnablePopup(true)
        setSelectedRange({ start, end });
        setShowCalendar(false);
    }
  };

  // When user will click outside the calendar
  useEffect(() => {
    function handleClickOutside(event) {
      if (!event || !event?.target || !calendarRef?.current) return;

      if (!calendarRef?.current?.contains(event?.target)) {
        setShowCalendar(false);
      }
    }
    
    if (showCalendar) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showCalendar]);

  const getNights = () => { //number of nights to be displayed will come from here
    if (selectedRange?.start && selectedRange?.end) {
      return differenceInDays(selectedRange?.end, selectedRange?.start);
    }
    return 2;
  };


  //these values wll be used in JSX down below
  //these are the values that are responsible for rendering the calendar, each month, week, day is getting calculated here
  const monthStart = startOfMonth(currentMonth);
  const monthEnd = endOfMonth(monthStart);
  const weekStart = startOfWeek(monthStart, { weekStartsOn: 1 });
  const weekEnd = endOfWeek(monthEnd, { weekStartsOn: 1 });
  const days = eachDayOfInterval({ start: weekStart, end: weekEnd });

  const NotifyButton = ({ day }) => {
    if (!isSoldOut(day) || !day || day < today || !isSameMonth(day, monthStart)) {
      return null;
    }

    return (
      <div 
        className={styles.notifyMe}
        onClick={(e) => {
          const startDate = new Date(day);
          const endDate = new Date(startDate);
          endDate.setDate(startDate.getDate() + 1);

          setShowNotifyPopup(true);
          setHoverDateRange({
            startDate: dayjs(startDate).format("YYYY-MM-DD"),
            endDate: dayjs(endDate).format("YYYY-MM-DD"),
          })
        }}
      >
        <span className={styles.notifyIcon}>
         <FaBell/>  
        </span> Notify Me
      </div>
    );
  };

  return (
    <>
      <div className={styles.calendarContainer}>
        {width > 900 && <p className={styles.checkInCheckout}>{t("checkin_checkout")}</p>}

        <div className={styles.dateContainer} onClick={() => setShowCalendar(!showCalendar)}>
          <img src={calendar} width={"20px"} alt="calendar" />
          <input 
            type="text"
            placeholder={t("checkin_checkout")}
            readOnly
            id={styles.dateInput}
            value={
              selectedRange?.start && selectedRange?.end
                ? `${format(selectedRange?.start, "dd MMM yy")} - ${format(selectedRange?.end, "dd MMM yy")}`
                : ""
            }
          />
        </div>

        {showCalendar && (
          <div className={styles.calendarPopup} ref={calendarRef}>
            <div className={styles.bookingHeader}>
              <div className={styles.dates} style={{ display: "flex", flexDirection: "row" }}>
                <span style={{border:"1px solid #E0E0E0", width:"auto", padding:"10px 12px 12px 10px", borderRadius:"5px"}}>{selectedRange?.start ? format(selectedRange?.start, "dd MMM yy") : "Checkin"}</span>
                <span style={{color:"var(--blue)"}} className={styles.nights}><b>{getNights()} nights</b></span>
                <span style={{border:"1px solid #E0E0E0", width:"auto", padding:"10px 12px 12px 10px", borderRadius:"5px"}}>{selectedRange?.end ? format(selectedRange?.end, "dd MMM yy") : "Checkout"}</span>
              </div>
            </div>

            <div className={styles.calendarHeader}>
              <button className={styles.prevnextBtn} onClick={handlePrevMonth}>{"<"}</button>
              <span>{format(currentMonth, "MMMM yyyy")}</span>
              <button className={styles.prevnextBtn} onClick={handleNextMonth}>{">"}</button>
            </div>

            <div className={styles.calendarGrid}>
              {["MO", "TU", "WE", "TH", "FR", "SA", "SU"].map((day) => (
                <div key={day} className={styles.dayHeader}>{day}</div>
              ))}
              {days?.map((day) => {
                const dateKey = format(day, "yyyy-MM-dd");
                const isPastDay = day < today;
                const isSoldOutDay = !isPastDay && isSoldOut(day);
                const isInMonth = isSameMonth(day, monthStart);
                const dayId = format(day, "yyyy-MM-dd");

                return (
                  <div 
                    key={day} 
                    className={`${styles.day} 
                      ${!isInMonth ? styles.outOfMonth : ''} 
                      ${isSoldOutDay ? styles.soldOut : ''} 
                      ${day < today ? styles.disabled : ''} 
                      ${isSameDay(day, selectedRange?.start) || isSameDay(day, selectedRange?.end) ? styles.selected : ''} 
                      ${selectedRange?.start && selectedRange?.end && day > selectedRange?.start && day < selectedRange?.end ? styles.inRange : ''}`.trim()}
                    onClick={() => {
                      if(isSoldOutDay && width <=600 && isInMonth && !isPastDay){
                        setHoveredDate(dayId);
                        handleDateClick(day);
                        return;
                      };

                      if(isInMonth && !isPastDay){
                        handleDateClick(day);
                        return;
                      };
                    }}
                    onMouseEnter={() => isSoldOutDay && isInMonth && setHoveredDate(dayId)}
                    onMouseLeave={() => setHoveredDate(null)}
                  >
                    {hoveredDate === dayId && <NotifyButton day={day} />}
                    {format(day, "d")}
                    <div className={`${styles.price} ${isSoldOutDay ? styles.soldOutPrice : ''}`} style={{ minHeight: "20px" }}>
                      {isPastDay ? (
                        ""
                      ) : isSoldOutDay ? (
                        <span>Sold&nbsp;Out</span>
                      ) : newPrices[dateKey] ? (
                        `₹${Math.floor(newPrices[dateKey]?.price)}`
                      ) : !isInMonth ? (
                        ""
                      ) : (
                        "- - -"
                      )}
                    </div>                  
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {width>900 && <p className={styles.guests}>{t("guests")}</p>}

        <div className={styles.peopleContainer} onClick={() => setEnablePopup(true)}>
          <img src={user} alt="user" width={"25px"} /> {totalPeople} {t(pluralWords(totalPeople, "guest"))}
        </div>
      </div>
      {
        showNotifyPopup && (
          <InventoryRetargModal
            onClose={() => setShowNotifyPopup(false)}
            dateRange={hoverDateRange}
            adults={adults}
            child={child}
          />
        )
      }
    </>
  );
};

export default BeaconCalendar;